import { Box, Stack } from '@mui/material'
import { UploadWithLink } from '../types/Upload'
import BlueprintPdfViewerButton from './BlueprintPdfViewerButton'

interface UploadPreviewProps {
  upload: UploadWithLink
}

export default function UploadPreview({ upload }: UploadPreviewProps) {
  return (
    <Stack spacing={2}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        sx={{ backgroundColor: 'white' }}
      >
        {upload.previewUrl && (
          <img
            src={upload.previewUrl}
            alt={upload.blueprint.name}
            style={{ maxWidth: '100%', maxHeight: '60vh', display: 'block' }}
          />
        )}
      </Box>

      <Stack direction="row" justifyContent="flex-end">
        <BlueprintPdfViewerButton upload={upload} variant="outlined" />
      </Stack>
    </Stack>
  )
}
